import { Suspense } from "react";

import { Outlet } from "react-router-dom";

import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";

import { ConfirmLogout, PageLoader } from "@/components/shared";

import { AppSidebar } from "./app-sidebar";
import { AuthGuard } from "./auth-guard";
import { Header } from "./header";

/**
 * Panel qobig'i: yon panel + sarlavha + kontent.
 *
 * Tuzilma ATAYLAB oddiy flex ustun. Ommaviy SPA dagi qobiq sarlavhani
 * `absolute top-12` bilan qo'yib, kontentga `h-[calc(100vh-80px)]` berardi:
 * ikkala raqam ham qo'lda hisoblangan va sarlavha balandligi bir piksel
 * o'zgarsa, pastda kesilgan chiziq paydo bo'lardi. Bu yerda sarlavha
 * `sticky`, kontent esa `flex-1 overflow-y-auto` — hech qanday hisob yo'q.
 *
 * Kontent TO'LIQ ENG: jadval va moderatsiya ekranlari o'rtada tor ustunda
 * emas, butun ekranda ochiladi.
 */
export default function AppLayout() {
  return (
    <AuthGuard>
      <SidebarProvider
        className="h-svh overflow-hidden"
        style={{ "--sidebar-width": "16rem" } as React.CSSProperties}
      >
        <AppSidebar />

        <SidebarInset className="flex min-h-0 min-w-0 flex-col overflow-hidden">
          <Header />

          <main className="min-h-0 w-full flex-1 overflow-y-auto p-4 sm:p-6">
            {/* Sahifa chunklari `lazy` — bu chegara yon panel va sarlavhani
                joyida qoldirib, faqat kontent maydonini yuklaydi. */}
            <Suspense fallback={<PageLoader className="min-h-[50vh]" />}>
              <Outlet />
            </Suspense>
          </main>
        </SidebarInset>

        {/* Chiqishni tasdiqlash oynasi qobiqda BIR MARTA chiziladi: uni
            yon panel ham, sarlavhadagi menyu ham ochadi. */}
        <ConfirmLogout />
      </SidebarProvider>
    </AuthGuard>
  );
}
